export enum RebateInvalidRecordsBulkActionModel {
	Reject = 1,
	Ignore = 2,
	Update = 3
}
